import './c-toggle-true-false.scss';
import template from './toggle-true-false.vhtml';

export default {
	template,
	props: {
		toggleData: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			isSelected: 0,
		};
	},
	mounted() {
		this.isSelected = 'value' in this.toggleData ? 1 : 0;
	},
	methods: {
		toggle( name ) {
			this.isSelected = this.isSelected !== 1 ? 1 : 0;
			this.$emit( 'selectOption', name, this.isSelected );	
		},     
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/toggle-true-false/toggle-true-false.js